import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const StyledBurger = styled.div`
  @media only screen and (min-width: calc(${themeGet(
      'breakpoints.lg',
    )} + 1px)) {
    display: none;
  }
  z-index: 101;
  position: absolute;
  top: 30px;
  right: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 1.5625rem;
  height: 1.1875rem;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;

  &:focus {
    outline: none;
  }

  div {
    width: 1.5625rem;
    height: 0.1875rem;
    background: ${themeGet('colors.spinTextDark')};
    border-radius: 10px;
    transition: all 0.3s linear;
    position: relative;
    transform-origin: 1px;
    z-index: 101;
    :first-child {
      transform: ${({ open }) => (open ? 'rotate(45deg)' : 'rotate(0)')};
    }

    :nth-child(2) {
      opacity: ${({ open }) => (open ? '0' : '1')};
      transform: ${({ open }) => (open ? 'translateX(20px)' : 'translateX(0)')};
    }

    :nth-child(3) {
      transform: ${({ open }) => (open ? 'rotate(-45deg)' : 'rotate(0)')};
    }
  }
`;
